import React from "react";
import { Row, Col, Typo, useClasses } from "../../";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-light-svg-icons";
//add text ellipses
const styles = (theme) => ({
    breadcrumb: {
        overflow: "hidden",
        whiteSpace: "nowrap",
    },
    breadcrumbSeperator: {
        margin: "0px 8px",
    },
    actions: {
        textAlign: "right",
    },
    wrapper: {
        backgroundColor: "rgb(225 225 225)",
        padding: "16px 32px 16px 32px",
        borderBottom: "1px solid #d9d9d9",
        zIndex: 99,
        [theme.breakpoints.down("sm")]: {
            padding: "8px",
        },
    },
    headline: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    },
    onClick: {
        cursor: "pointer",
    },
});
export default function PageHead(props) {
    const classes = useClasses(styles);
    return (React.createElement("div", { className: classes.wrapper },
        React.createElement(Row, { verticalAlign: "center" },
            props.icon && (React.createElement(Col, { sm: "hidden-down", md: "auto" }, props.icon)),
            React.createElement(Col, { override: { col: classes.breadcrumb }, sm: "hidden-down", md: "rest-fixed" },
                React.createElement(Typo, { override: { className: classes.headline }, variant: "h1", margin: "none" }, props.title),
                props.breadcrumbs.map((item, index) => {
                    const isNotLast = index + 1 < props.breadcrumbs.length;
                    return (React.createElement(React.Fragment, { key: index + "-breadcrumb" },
                        item.to && React.createElement("a", { href: item.to }, item.label),
                        !item.to && (React.createElement("span", { className: item.onClick && classes.onClick, onClick: () => {
                                if (item.onClick)
                                    item.onClick();
                            } }, item.label)),
                        isNotLast && (React.createElement(FontAwesomeIcon, { className: classes.breadcrumbSeperator, icon: faChevronRight }))));
                })),
            props.children && (React.createElement(Col, { override: { col: classes.actions }, md: "auto" }, props.children)))));
}
